module.exports = __webpack_public_path__ + "img/12.55bb5998.jpg";